import { readTokenFromStorage } from '@aibees/shared/auth';
import type { AxiosInstance } from 'axios';

export function addAuthTokenInterceptor(instance: AxiosInstance) {
  instance.interceptors.request.use((config) => {
    if (!config.headers.Authorization) {
      const token = readTokenFromStorage();
      if (token) config.headers.Authorization = `Bearer ${token.access_token}`;
    }
    return config;
  });
}
